import React from 'react';
import ABSImage from '../ABSImage';
import classnames from 'classnames';
import routeConfig from '../../abs/config/routeConfig';
import ABSLink from '../ABSLink';
import ABSResolvePhoneOrMail from '../ABSResolvePhoneOrMail';
import authService from '../../abs/services/auth/authService';
import './index.less';

const image = require('../../assets/images/errorimage.png');

export interface IProps {
  message?: string;
  className?: string;
}

class ABSErrorPage extends React.PureComponent<IProps> {
  onRefresh = () => {
    location.reload();
  };

  onLogout = () => {
    authService.removeAllCache();
    location.href = '/';
  };

  render() {
    const defaultMessage = '请刷新页面 , 或直接联系我们';
    const { message = defaultMessage, className } = this.props;
    const clazz = classnames('abs-error-page', className);
    return (
      <div className={clazz}>
        <ABSImage logo={image} width={205} height={112} />
        <p className="abs-error-page-text">{message || defaultMessage}</p>
        <div className="middle-view">
          <a className="text-style" href={'javascript：void(0);'}>
            电话 : 请联系{' '}
          </a>
          <ABSResolvePhoneOrMail />
          <div className="middle-righr-view">
            <p className="email-text">邮箱 : </p>
            <ABSResolvePhoneOrMail type="mail" />
          </div>
        </div>

        <div className="foot-view">
          <a onClick={this.onRefresh}>刷新</a>
          <p className="line-view">|</p>
          <ABSLink to={routeConfig.home}>返回首页</ABSLink>
          <p className="line-view">|</p>
          <a onClick={this.onLogout}>退出登录</a>
        </div>
      </div>
    );
  }
}

export default ABSErrorPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSErrorPage/index.tsx